<section [style]="styles">
  @if (labelEnabled()) {
    <blaze-element-label
      [color]="props?.style?.general?.title?.color1"
      [extendInputPadding]="elementContext?.extendInputPadding"
      [fontFamily]="props?.style?.labelBlock?.fontFamily"
      [fontSize]="props?.style?.labelBlock?.fontSize"
      [fontStyle]="props?.style?.labelBlock?.fontStyle"
      [fontWeight]="props?.style?.labelBlock?.fontWeight"
      [horizontalAlign]="props?.content?.title?.align"
      [icon]="props?.content?.title?.icon"
      [iconColor]="props?.content?.title?.iconColor?.color1"
      [iconPosition]="props?.content?.title?.iconPosition"
      [iconSize]="props?.style?.labelBlock?.iconSize"
      [isUsingOldPaddingStrategy]="isUsingOldPaddingStrategy"
      [lineHeight]="props?.style?.labelBlock?.lineHeight"
      [position]="props?.content?.title?.position"
      [tooltip]="props?.content?.title?.tooltip"
      [width]="props?.content?.title?.width"
    >
      {{ labelText() }}
    </blaze-element-label>
  }
  <div
    #inputContainer
    class="input"
    tabindex="0"
    blazeResized
    [style]="inputWrapperStyles"
    [class.validation-error]="hasValidationError"
    [class.opened]="isMenuOpen"
    (click)="onInputContainerClick($event)"
    (elementResized)="onResized($event)"
  >
    @if (prefix()) {
      <span class="prefix">{{ prefix() }}</span>
    }
    @let selectionTooltip =
      isTouchMode()
        ? undefined
        : (selected | optionLabel: labelField : defaultValue : placeholder());
    <input
      #filterInput
      type="text"
      class="filter-input"
      autocomplete="off"
      [blazeTooltip]="selectionTooltip"
      [readonly]="isReadOnly()"
      [placeholder]="placeholder()"
      (blur)="setInputMode(false)"
      (focus)="setInputMode(true)"
      (input)="emitUserInput($any($event.target)?.value)"
      (keydown)="onInputKeyDown($event)"
      (keyup)="onInputKeyUp()"
      (change)="filterOptions()"
    />
    @if (suffix()) {
      <span class="suffix">{{ suffix() }}</span>
    }
    @if (!isReadOnly()) {
      <span class="menu-trigger" [class.opened]="isMenuOpen">
        <mat-icon svgIcon="icon_chevron_down_16" />
      </span>
    }
    <div
      class="menu-fake-trigger"
      [matMenuTriggerFor]="menu"
      [matMenuTriggerRestoreFocus]="false"
    ></div>
  </div>

  <mat-menu
    #menu="matMenu"
    xPosition="after"
    yPosition="below"
    [overlapTrigger]="false"
    [hasBackdrop]="false"
    class="{{ elementKeyRoot }} {{ elementKey }}"
  >
    <!-- Defer the content to be rendered when the menu is open -->
    <ng-template matMenuContent>
      @let context =
        {
          options: displayedOptions$ | async,
          isPending: isPending$ | async,
        };
      @if (context.isPending && !isPaginated) {
        <div class="menu-content">
          <button
            mat-menu-item
            disableRipple
            class="relative pointer-events-none loading-indicator-item"
          >
            <blaze-element-loading-indicator
              [isVisible]="true"
              [fadeEnabled]="false"
              mode="theme"
            />
          </button>
        </div>
      }

      @if (!context.isPending || isPaginated) {
        <div
          class="menu-content"
          [blazeDropdownInfiniteScroll]="infiniteScrollTrigger"
          [blazeDropdownInfiniteScrollEnabled]="blazeDropdownInfiniteScrollEnabled"
          (scrollBottom)="loadNextPage()"
        >
          @if (displayClearOption) {
            <button mat-menu-item disableRipple class="separator-option" (click)="onSelect({})">
              Clear selection
            </button>
          }

          @for (item of displayedOptions$ | async | slice: 0 : 1000; track $index) {
            @let itemLabel = item | optionLabel: labelField : defaultValue : placeholder();
            @if (item[labelField] !== '🗑clear') {
              <button
                mat-menu-item
                [blazeTooltip]="isTouchMode() ? undefined : itemLabel"
                [matTooltipShowDelay]="300"
                [class.active]="item[valueField] === selected?.[valueField]"
                (click)="onSelect(item)"
              >
                <span>{{ itemLabel }}</span>
                @if (item[valueField] === selected?.[valueField]) {
                  <span class="ml-auto">
                    <mat-icon svgIcon="icon_check_24" />
                  </span>
                }
              </button>
            }
          }
          <div #infiniteScrollTrigger class="infinite-scroll-trigger"></div>
          @if (context.isPending && isPaginated) {
            <button
              mat-menu-item
              disableRipple
              class="relative pointer-events-none loading-indicator-item"
            >
              <blaze-element-loading-indicator
                [isVisible]="true"
                [fadeEnabled]="false"
                mode="theme"
              />
            </button>
          }
          @if (showNoRowsMessage$ | async) {
            <button mat-menu-item disableRipple class="pointer-events-none no-items-option">
              No results available...
            </button>
          }
        </div>
      }
    </ng-template>
  </mat-menu>
</section>

@if (hasValidationError) {
  <div class="validation" [style]="validationStyles">
    {{ formState?.messages?.required || formState?.messages?.invalid || '' }}
  </div>
}
